import axios from "axios";

const API_BASE = (process.env.REACT_APP_BASE_URL || "").replace(/\/$/, "");

export const sendMessage = async (message, history = [], context = {}) => {
  try {
    const res = await axios.post(
      `${API_BASE}/api/ai/chat`,
      { message, history, context },
      {
        timeout: 30000,
        withCredentials: false,
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;

  } catch (error) {
    return {
      failed: true,
      reply: { type: "text", data: error.response?.data?.error || "I couldn't reach Tracy just now. Please check your connection and try again." }
    };
  }
};
